export * from './wealth-health-score.component';
